export default __webpack_public_path__ + "static/profileimage2-205c51b39d778528740650b8513e503c.png";